import React from 'react';
import { Box, Flex, Text } from 'rebass';
import TimelineItemRail from './TimelineItemRail';
import { buildFooterText } from './helpers';
import TimelineItem from './TimelineItem';
import TimelineItemSpacer from './TimelineItemSpacer';
import { HistoryItem } from './types';

type TimelineDayProps = {
  dayIndex: number;
  dayFormatted: string;
  isFirstDate: boolean;
  isLastDate: boolean;
  noRail?: boolean;
  historyItems: HistoryItem[];
};

const TimelineDay: React.FC<TimelineDayProps> = ({
  dayIndex,
  dayFormatted,
  isFirstDate,
  isLastDate,
  noRail = false,
  historyItems,
}) => {
  return (
    <Box key={dayIndex} pl={noRail ? 0 : 2}>
      <Flex alignItems="stretch">
        {!isFirstDate && !noRail && <TimelineItemRail noDot />}
        <Text variant="bodyTimelineItalic" textAlign="center" flexGrow={1}>
          {dayFormatted}
        </Text>
      </Flex>

      {historyItems.map((historyItem, itemIndex) => {
        const computedFooterText: string | undefined =
          buildFooterText(historyItem);
        // if (
        //   historyItems[itemIndex + 1] &&
        //   buildFooterText(historyItems[itemIndex + 1]) ===
        //     computedFooterText
        // ) {
        //   computedFooterText = undefined
        // }

        const isFirst = itemIndex === 0;
        const isLast = itemIndex + 1 === historyItems.length;
        const isInitial = isFirst && isFirstDate;
        const isFinal = isLast && isLastDate;

        return (
          <>
            <TimelineItem
              key={historyItem.id}
              noRail={noRail}
              isInitial={isInitial}
              isFirst={isFirst}
              isLast={isLast}
              isFinal={isFinal}
              footer={computedFooterText}
              {...historyItem}
            />
            {!isLast && <TimelineItemSpacer noRail={noRail} />}
          </>
        );
      })}
      {!isLastDate && <TimelineItemSpacer noRail={noRail} height={15} />}
    </Box>
  );
};

export default TimelineDay;
